import React, { useEffect, useState, useRef, forwardRef, useContext } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import InfiniteScroll from 'react-infinite-scroller';
import AKPopup from '@atlaskit/popup';
import debounce from 'lodash/debounce';
import SearchBar from 'ui/components/SearchBar';
import PageLoader from 'ui/components/Loaders/PageLoader';
import Tooltip from 'ui/components/Tooltip';
import {makeSelectGifs, makeSelectTextAreaNumberOfLines} from 'ui/containers/App/selectors';
import {
  getRecentGifs,
  getTrendingGifs,
  getSearchedGifs,
} from 'ui/containers/App/actions.js';
import {GIF, GIF_UI_TEXT as UI_TEXT} from 'common/constants';
import PopupExitIcon from 'assets/icons/popupExitIcon.svg';

import InfoIcon from 'assets/icons/info.svg';
import { useOnClickOutside } from 'utils/hooks/useOnClickOutside';
import {
  PopupContainer,
  GifContainer,
  GifLayout,
  GifPreview,
  PoweredByText,
  LoaderContainer,
  NoSearchText,
  ReplaceBtn,
  TriggerIcon, PopupWrapper,
} from './styled';
import {Text, FlexContainer} from "common/styles";
import {MESSAGE_TYPES} from "../../containers/App/constants";
import {saveEventToLocalStorage} from "../../../utils/saveToLocalStorage";
import {eventTypes} from "../../../utils/eventTypes";
import styled from "styled-components";
import { useConfig } from 'context';
const PopupComponent = forwardRef(({ children, ...props }, ref) => {
    return (
        <PopupWrapper innerRef={ref} {...props} id={'gifPopup'}>
          <div>{children}</div>
        </PopupWrapper>
    )
});

const Gif = ({
  gifId,
  gifsData,
  formikFieldName,
  hasGif,
  getRecentGifsStart,
  getTrendingGifsStart,
  getSearchedGifsStart,
  addGifToStep,
  handleSend,
  textAreaNumberOfLines,
  pushMessage,
  handleSendingMessageToPusher,
  textColor,
  ...props
}) => {

  let isInitialCall = false;
  let prevConversationId = null;

  const GifIcon = styled(({ textColor }) => (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.75" y="0.75" width="14.5" height="14.5" rx="3.25" stroke={textColor} stroke-width="1.5"/>
        <path d="M5.24035 10.06C4.86435 10.06 4.54235 9.998 4.27435 9.874C4.01035 9.746 3.80435 9.562 3.65635 9.322C3.51235 9.078 3.43435 8.784 3.42235 8.44C3.41835 8.268 3.41635 8.084 3.41635 7.888C3.41635 7.692 3.41835 7.506 3.42235 7.33C3.43435 6.994 3.51235 6.708 3.65635 6.472C3.80435 6.236 4.01235 6.056 4.28035 5.932C4.55235 5.804 4.87235 5.74 5.24035 5.74C5.53635 5.74 5.79635 5.778 6.02035 5.854C6.24435 5.93 6.43235 6.03 6.58435 6.154C6.73635 6.274 6.85235 6.406 6.93235 6.55C7.01235 6.694 7.05435 6.832 7.05835 6.964C7.05835 7 7.04635 7.032 7.02235 7.06C6.99835 7.084 6.96635 7.096 6.92635 7.096H6.18235C6.14235 7.096 6.11035 7.088 6.08635 7.072C6.06635 7.056 6.04835 7.032 6.03235 7C6.00435 6.928 5.95835 6.856 5.89435 6.784C5.83435 6.708 5.75235 6.644 5.64835 6.592C5.54435 6.54 5.40835 6.514 5.24035 6.514C4.98835 6.514 4.78835 6.58 4.64035 6.712C4.49635 6.844 4.41835 7.06 4.40635 7.36C4.39435 7.704 4.39435 8.054 4.40635 8.41C4.41835 8.722 4.49835 8.946 4.64635 9.082C4.79835 9.218 5.00035 9.286 5.25235 9.286C5.41635 9.286 5.56235 9.258 5.69035 9.202C5.82235 9.142 5.92635 9.05 6.00235 8.926C6.07835 8.802 6.11635 8.644 6.11635 8.452V8.302H5.46235C5.42235 8.302 5.38835 8.288 5.36035 8.26C5.33235 8.228 5.31835 8.192 5.31835 8.152V7.768C5.31835 7.724 5.33235 7.688 5.36035 7.66C5.38835 7.632 5.42235 7.618 5.46235 7.618H6.93235C6.97635 7.618 7.01235 7.632 7.04035 7.66C7.06835 7.688 7.08235 7.724 7.08235 7.768V8.422C7.08235 8.766 7.00635 9.06 6.85435 9.304C6.70635 9.548 6.49235 9.736 6.21235 9.868C5.93635 9.996 5.61235 10.06 5.24035 10.06ZM7.96412 10C7.92012 10 7.88412 9.986 7.85612 9.958C7.82812 9.93 7.81412 9.894 7.81412 9.85V5.95C7.81412 5.906 7.82812 5.87 7.85612 5.842C7.88412 5.814 7.92012 5.8 7.96412 5.8H8.64212C8.68612 5.8 8.72212 5.814 8.75012 5.842C8.77812 5.87 8.79212 5.906 8.79212 5.95V9.85C8.79212 9.894 8.77812 9.93 8.75012 9.958C8.72212 9.986 8.68612 10 8.64212 10H7.96412ZM9.8274 10C9.7834 10 9.7474 9.986 9.7194 9.958C9.6914 9.93 9.6774 9.894 9.6774 9.85V5.95C9.6774 5.906 9.6914 5.87 9.7194 5.842C9.7474 5.814 9.7834 5.8 9.8274 5.8H12.5034C12.5474 5.8 12.5834 5.814 12.6114 5.842C12.6394 5.87 12.6534 5.906 12.6534 5.95V6.46C12.6534 6.504 12.6394 6.54 12.6114 6.568C12.5834 6.596 12.5474 6.61 12.5034 6.61H10.6134V7.624H12.3834C12.4274 7.624 12.4634 7.638 12.4914 7.666C12.5194 7.694 12.5334 7.73 12.5334 7.774V8.284C12.5334 8.324 12.5194 8.358 12.4914 8.386C12.4634 8.414 12.4274 8.428 12.3834 8.428H10.6134V9.85C10.6134 9.894 10.5994 9.93 10.5714 9.958C10.5434 9.986 10.5074 10 10.4634 10H9.8274Z" fill={textColor}/>
      </svg>
    ))`
    width: 15.18px;
    height: 14.77px;
    align-items: center;
    justify-content: center;
    /* display: flex; */
    margin: 0;
  `;


  const { recent, trending, searched } = gifsData;
  const { loading: recentGifsLoading, data: recentGifsData } = recent;
  const {
    loading: trendingGifsLoading,
    data: trendingGifsData,
    pagination: trendingGifsPagination,
  } = trending;
  const {
    loading: searchedGifsLoading,
    data: searchedGifsData,
    pagination: searchedGifsPagination,
  } = searched;
  const scrollRef = useRef(null);
  const popupRef = useRef(null);

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [selectedGif, setSelectedGif] = useState({ id: gifId });
  const { config, loading: configLoading, error: configError, hasConfig } = useConfig();
  const {REACT_APP_GIPHY_KEY} = config || {};
  useEffect(() => {
    if (isPopupOpen) getRecentGifsStart({meta: {}});

    if (isPopupOpen && !isInitialCall) {
      isInitialCall = true;
      fetchTrendingGifs();
    }
    return () => {
      if (searchKeyword) setSearchKeyword('');
    };
  }, [isPopupOpen]);

  const openPopupHandler = () => setIsPopupOpen(true);
  const closePopupHandler = () => setIsPopupOpen(false);

  useOnClickOutside({
    ref: popupRef,
    handler: closePopupHandler,
  });

  const fetchTrendingGifs = () => {
    if (!trendingGifsLoading && REACT_APP_GIPHY_KEY) {
      const meta = {
        apiKey: REACT_APP_GIPHY_KEY,
        endpoint: GIF.TRENDING_ENDPOINT,
        rating: GIF.RATING,
        limit: GIF.LIMIT,
        offset: trendingGifsPagination?.count + trendingGifsPagination?.offset || 0,
      };
      getTrendingGifsStart({ meta });
    }
  };

  const fetchSearchedGifs = e => {
    const inputVal =
      typeof e?.target?.value !== 'undefined' && typeof e?.target?.value === 'string'
        ? e.target.value.trim()
        : searchKeyword;
    const resetQuery = inputVal !== searchKeyword;
    if (resetQuery) {
      if(scrollRef.current?.scrollTop) scrollRef.current.scrollTop = 0; // scroll to top
    }
    if (!searchedGifsLoading && inputVal.length > 0 && REACT_APP_GIPHY_KEY) {
      const meta = {
        apiKey: REACT_APP_GIPHY_KEY,
        endpoint: GIF.SEARCH_ENDPOINT,
        rating: GIF.RATING,
        limit: GIF.LIMIT,
        offset: resetQuery
          ? 0
          : searchedGifsPagination?.count + searchedGifsPagination?.offset || 0,
        q: inputVal,
        resetQuery,
      };
      getSearchedGifsStart({ meta });
    }
    setSearchKeyword(inputVal);
  };
  const recentGifsIds = recentGifsData.map(recentGif => recentGif.id);

  const gifs =
    searchKeyword && searchedGifsData.length !== 0 // display searched gifs
      ? searchedGifsData
      : searchKeyword && searchedGifsData.length === 0 // if no gifs based on search display trending gifs
      ? trendingGifsData
      : [
          ...recentGifsData,
          ...trendingGifsData.filter(trendingGif => {
            return !recentGifsIds.includes(trendingGif.id);
          }),
        ]; // display both recent and trending gif by default
  const infiniteScrollHasMore =
    searchKeyword && searchedGifsData?.length !== 0
      ? Boolean(searchedGifsPagination?.count)
      : Boolean(trendingGifsPagination?.count);
  const infiniteScrollLoadMore =
    searchKeyword && searchedGifsData?.length !== 0 ? fetchSearchedGifs : fetchTrendingGifs;
  const isSearchResultEmpty =
    !searchedGifsLoading && searchKeyword && searchedGifsData.length === 0;

  const popupTrigger = ({ ref, ...props }) => (
    <TriggerIcon {...props} innerRef={ref} onClick={openPopupHandler}>
        <Tooltip
          content={GIF.TOOLTIP}
          truncate={true}
          position="top"
          hideTooltipOnClick={true}
          marginBottom={'7px'}
          right={'18px'}
        >
          <GifIcon textColor={textColor}/>
        </Tooltip>
    </TriggerIcon>
  );

  const popupContent = () => {
    return (
      <PopupContainer textAreaNumberOfLines={ textAreaNumberOfLines <= 5 ? textAreaNumberOfLines : 5}>
        <div ref={popupRef}>
        <SearchBar
          showIcon={true}
          placeholder={GIF.INPUT_PLACEHOLDER}
          border={'1px solid #DADDE4'}
          borderRadius={'6px'}
          onChange={debounce(fetchSearchedGifs, 500)}
        />
        {isSearchResultEmpty &&
          <>
            <NoSearchText>{UI_TEXT.EMPTY}</NoSearchText>
            <Text fontSize={16} lineHeight={19} margin={'20px 0 0'}>
              Trending
            </Text>
          </>
        }
        <GifContainer innerRef={scrollRef} changeHeight={isSearchResultEmpty}>
          <InfiniteScroll
            initialLoad={false}
            pageStart={0}
            loadMore={infiniteScrollLoadMore}
            hasMore={infiniteScrollHasMore}
            loader={
              <LoaderContainer>
                <PageLoader />
              </LoaderContainer>
            }
            useWindow={false}
          >
            <GifLayout>
              {gifs.map(gif => {
                const { id, previewGif, previewStill } = gif;
                return (
                  <GifPreview
                    key={id}
                    isSelected={id === selectedGif?.id}
                    src={previewStill?.url}
                    height={previewStill?.height}
                    onMouseEnter={e => (e.target.src = previewGif?.url)}
                    onMouseLeave={e => (e.target.src = previewStill?.url)}
                    onClick={e => {
                      e.stopPropagation();
                      const message = {
                        img: null,
                        name: null,
                        lead: true,
                        gifs: {
                          url: gif?.original?.url,
                          type: 'gif',
                          size: gif?.original?.size,
                          name: gif?.name,
                        },
                        isGif: true,
                        time: Date.now(),
                        type: MESSAGE_TYPES.attachments,
                        id: gif?.id,
                      };
                      handleSendingMessageToPusher({gif, id: gif?.id})
                      pushMessage({ meta: { message } });
                      closePopupHandler()
                    }}
                  />
                );
              })}
            </GifLayout>
          </InfiniteScroll>
        </GifContainer>
        {(gifId && selectedGif?.id && gifId !== selectedGif.id) &&
          <>
            <FlexContainer padding={'6px 0 0'} margin={'0 0 16px'}>
              <img src={InfoIcon} />
              <Text color={'#283446'} fontSize={12} lineHeight={14} margin={'0 0 0 10px'}>
                {UI_TEXT.REPLACE}
              </Text>
              <ReplaceBtn
                onClick={() => {
                  if (addGifToStep) addGifToStep(selectedGif, formikFieldName, hasGif);
                  closePopupHandler();
                }}
              >
                Replace
              </ReplaceBtn>
            </FlexContainer>
          </>
        }
        <PoweredByText>
          Powered by <span>Giphy</span>
        </PoweredByText>
      </div>
      </PopupContainer>
    );
  };

  return (
    <AKPopup
      isOpen={isPopupOpen}
      onClose={closePopupHandler}
      placement="bottom-end"
      offset={'23px,18px'}
      trigger={popupTrigger}
      zIndex={999999999999999999}
      popupComponent={PopupComponent}
      content={popupContent}
      textAreaNumberOfLines={textAreaNumberOfLines}
    />
  );
};

export const mapStateToProps = (state, props) => {
  return createStructuredSelector({
    gifsData: makeSelectGifs(),
    textAreaNumberOfLines: makeSelectTextAreaNumberOfLines(),
  });
};

export const mapDispatchToProps = dispatch => {
  return {
    getRecentGifsStart: ({ meta }) => dispatch(getRecentGifs.start({ meta })),
    getTrendingGifsStart: ({ meta }) => dispatch(getTrendingGifs.start({ meta })),
    getSearchedGifsStart: ({ meta }) => dispatch(getSearchedGifs.start({ meta })),
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default withConnect(Gif);
